import React from 'react';
import { useTranslation } from 'react-i18next';

import type { CombinedFacet } from '../../utils/reselectors';

interface FilterBarItemProps {
  facet: CombinedFacet;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const FilterBarItem = ({ facet, onClick }: FilterBarItemProps) => {
  const { t } = useTranslation('search');

  return (
    <button
      type="button"
      className={`action-group-btn${(facet?.selectionCount || 0) > 0 ? ' is-active' : ''}`}
      title={t('Open the filter', { ns: 'search', name: facet.displayName })}
      onClick={onClick}
      data-testid={`quick-filter-button-${facet.id}`}
    >
      {facet.displayName}
    </button>
  );
};

export default FilterBarItem;
